/**
 * Chat abstraction layer
 *    - Provides a unified interface for chat functionality
 *    - Swap providers by changing the getter
 *    - 3rd-party script gets injected via gatsby-ssr.js
 */

const chat = {
  get api() {
    return typeof window !== "undefined" ? window?.Mangomint : null;
  },

  show: () => chat.api?.showWebChat?.(),
  hide: () => chat.api?.hideWebChat?.(),
  open: () => chat.api?.openWebChat?.(),
  close: () => chat.api?.closeWebChat?.(),
  isAvailable: () => !!chat.api,
};

export default chat;
